import { withInstall } from "../utils";
import _Button from "./Button";
const Button = withInstall(_Button);
var stdin_default = Button;
export {
  Button,
  stdin_default as default
};
